
import Layers from "slotworks/graphics/layers/layers";
import Point from "slotworks/utils/geom/point";

export default class LinesComponent {

    private lines: Array<PIXI.Graphics | PIXI.Sprite>;

    constructor(lineDefinitions: Point[][]) {
        this.drawLines(lineDefinitions);
    }

    public drawLines(lineDefinitions: Point[][]) {
        if (this.lines && this.lines.length) {
            for (const line of this.lines) {
                if (line instanceof PIXI.Graphics) {
                    line.clear();
                }

                Layers.Paylines.remove(line);
            }
        }

        this.lines = [];

        for (let lineIndex = 0; lineIndex < lineDefinitions.length; lineIndex++) {
            const lineDefinition = lineDefinitions[lineIndex];

            let line: PIXI.Graphics | PIXI.Sprite;

            const lineSprite = Layers.Paylines.getSprite("line_" + (lineIndex + 1));

            if (lineSprite) {
                // Graphical lines (assetworks)
                line = lineSprite;
            } else {
                // Draw them ourselves
                line = this.drawLine(lineDefinition, 10, 0xff0000, 0.2);
                this.drawLine(lineDefinition, 8, 0xff0000, 0.4, line);
                this.drawLine(lineDefinition, 6, 0xff0000, 0.6, line);
                this.drawLine(lineDefinition, 2, 0xffffff, 1, line);
            }

            line.visible = false;

            this.lines.push(line);

            Layers.Paylines.add(line);
        }
    }

    public showLine(line: number, show: boolean) {
        this.lines[line - 1].visible = show;
    }

    public hideAllLines() {
        for (const line of this.lines) {
            line.visible = false;
        }
    }

    private drawLine(lineDefinition: Point[], weight: number, color: number, alpha: number, graphics?: PIXI.Graphics): PIXI.Graphics {
        if (!graphics) {
            graphics = new PIXI.Graphics();
        }

        graphics.lineStyle(weight, color, alpha);

        const firstPosition = lineDefinition[0];
        const firstSymbolPosition = Layers.MatrixContent.getPosition("symbol_" + (firstPosition.x + 1) + "_" + (firstPosition.y + 1));
        graphics.moveTo(firstSymbolPosition.x, firstSymbolPosition.y + firstSymbolPosition.height * 0.5);

        for (const point of lineDefinition) {
            const x = point.x + 1;
            const y = point.y + 1;

            const symbolPosition = Layers.MatrixContent.getPosition(`symbol_${x}_${y}`);

            graphics.lineTo(symbolPosition.x + symbolPosition.width * 0.5, symbolPosition.y + symbolPosition.height * 0.5);
        }

        const lastPosition = lineDefinition[lineDefinition.length - 1];
        const lastSymbolPosition = Layers.MatrixContent.getPosition("symbol_" + (lastPosition.x + 1) + "_" + (lastPosition.y + 1));
        graphics.lineTo(lastSymbolPosition.x + lastSymbolPosition.width, lastSymbolPosition.y + lastSymbolPosition.height * 0.5);

        return graphics;
    }

}



// WEBPACK FOOTER //
// ./~/slotworks/components/lines/lines-component.ts